import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke082aRequest, Sgke082aResponse, Sgke082aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke082aService {

  /**
   * コンストラクタ
   * @param {Sgke082aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke082aService
   */
  constructor(public service: Sgke082aService, public apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * Sgke082aAPI実行
   *
   * @param {Sgke082aRequest} request
   * @return {*}  {Observable<Sgke082aResponse>}
   * @memberof UsedSgke082aService
   */
  public doSgke082a(request: Sgke082aRequest): Observable<Sgke082aResponse> {

    return this.service.sgke082aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE082A');
          return throwError(err.message);
        })
      );
  }

}

